import React from "react";
import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import image1 from "./img/slider/dining/1.webp";
import image2 from "./img/slider/dining/2.webp";
import image3 from "./img/slider/dining/3.webp";

const sliderOptions = {
  items: 1,
  loop: true,
  autoplay: true,
  autoplayTimeout: 3000,
  nav: false,
  dots: true,
};

const sliderItems = [
  {
    image: image1,
    title: "Prepared with Love and Care",
    subtitle: "Coastal flavors, served with sophistication",
    mask: "rgba(0, 0, 0, 0.5)",
    textAlign: "start",
  },
  {
    image: image2,
    title: "Only the best",
    subtitle: "Planting every texture",
    mask: "rgba(0, 0, 0, 0.4)",
    textAlign: "center",
  },
  {
    image: image3,
    title: "Mouth-watering delicacies",
    subtitle: "Gourmet experiences, waves as your soundtrack.",
    mask: "rgba(0, 0, 0, 0.3)",
    textAlign: "end",
  },
];

export default function DiningSlider() {
  return (
    <div id="carousel-home">
      <OwlCarousel className="owl-theme" {...sliderOptions}>
        {sliderItems.map((slide, index) => (
          <div
            key={index}
            className="owl-slide"
            style={{ 
              position: "relative",
              height: "100vh",
              overflow: "hidden"
            }}
          >
            {/* Background Image */}
            <div
              style={{
                backgroundImage: `url(${slide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                filter: "brightness(0.9)",
              }}
            />
            
            {/* Dark Overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: slide.mask,
                zIndex: 1,
              }}
            />
            
            {/* Text Content */}
            <div
              style={{
                position: "relative",
                zIndex: 2,
                height: "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div className="container">
                <div className={`row justify-content-${slide.textAlign}`}>
                  <div className="col-lg-10 col-xl-8">
                    <div 
                      className={`slide-text text-${slide.textAlign} white`}
                      style={{
                        padding: "0 40px",
                        maxWidth: "800px",
                        margin: "0 auto"
                      }}
                    >
                      <small 
                        className="owl-slide-animated owl-slide-title"
                        style={{
                          color: "#ebd7b2",
                          fontFamily: "Poppins, sans-serif",
                          fontStyle: "normal",
                          fontWeight: "600",
                          fontSize: "13px",
                          lineHeight: "1.5",
                          textTransform: "uppercase",
                          letterSpacing: "2px",
                          margin: "0 0 15px 0",
                          display: "block"
                        }}
                      >
                        {slide.title}
                      </small>
                      <h2 
                        className="owl-slide-animated owl-slide-title-2"
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontStyle: "normal",
                          fontWeight: "500",
                          color: "rgb(255, 255, 255)",
                          fontSize: "40px",
                          lineHeight: "52px",
                          textTransform: "uppercase",
                          letterSpacing: "1px",
                          margin: "10px 0 0 0",
                        }}
                      >
                        {slide.subtitle}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </OwlCarousel>
      <div className="mouse_wp">
        <a href="#first_section" className="btn_scrollto">
          <div className="mouse"></div>
        </a>
      </div>
    </div>
  );
}